import { render, staticRenderFns } from "./find-pwd.vue?vue&type=template&id=355b13f9&scoped=true"
import script from "./find-pwd.vue?vue&type=script&lang=js"
export * from "./find-pwd.vue?vue&type=script&lang=js"
import style0 from "./find-pwd.vue?vue&type=style&index=0&id=355b13f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b13f9",
  null
  
)

export default component.exports